import { BlockUI as BlockUIs } from 'primereact/blockui';  

const BlockUI = ({...rest}) => {

    return (
        <BlockUIs {...rest} />
    )

};

export default BlockUI;